module.exports = __webpack_public_path__ + "static/img/c2-waving.78c7cf2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatars/c2-waving.gif
// module id = 24
// module chunks = 0